// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Model
import { useFormQuestionAnswersData } from '@lyon/scoped-models/form/FormQuestionAnswersData';

// ANCHOR Types
import { INDEX_TO_LETTER, INDEX_TO_LETTER_TYPE } from '@lyon/utils/api/results/forms';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { LyonUpdateMultipleChoiceAnswerListItem } from './LyonUpdateMultipleChoiceAnswerListItem';

// ANCHOR Styles
import { BLOCK } from './styles';

export const LyonUpdateMultipleChoiceAnswerList = constant(() => {
  const answers = useFormQuestionAnswersData();

  if (answers?.length) {
    return (
      <Block overrides={BLOCK}>
        {
          answers.map((answer, index) => (
            <LyonUpdateMultipleChoiceAnswerListItem
              answer={answer}
              key={index}
              prefix={INDEX_TO_LETTER[index as INDEX_TO_LETTER_TYPE]}
            />
          ))
        }
      </Block>
    );
  }

  return null;
});
